import { useMemo } from 'react';

// eslint-disable-next-line react-compiler/react-compiler
/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line react-hooks/use-memo
export const useMemoArray = <T>(array: T[]) => useMemo(() => array, array);
